//enum
import {NO_CONTRIBUTION} from '../constants';
import {ATTENDEE_STATUS, TABLE_STATUS} from '../enums/tables.enum';

export const downloadFile = (file: File, tile: string) => {
	const blobData = new Blob([file]);

	const downloadLink = document.createElement('a');
	downloadLink.href = window.URL.createObjectURL(blobData);
	downloadLink.download = `${tile}.csv`;

	document.body.appendChild(downloadLink);
	downloadLink.click();

	document.body.removeChild(downloadLink);
};

export const getTableStatusStyle = (status: string, isHover?: boolean) => {
	let mainColor = 'var(--success-600)';
	let dotColor = 'var(--success-600)';

	if (status === NO_CONTRIBUTION) {
		mainColor = 'var(--neutral-500)';
	}

	if (status === TABLE_STATUS.PENDING) {
		mainColor = 'var(--warning-600)';
		dotColor = 'var(--warning-500)';
	} else if (status === TABLE_STATUS.CLOSED || status === ATTENDEE_STATUS.PENDING) {
		mainColor = 'var(--neutral-500)';
		dotColor = 'var(--neutral-500)';
	}

	const baseStyles = {
		color: `${mainColor} !important`,
		display: 'flex',
		justifyContent: 'flex-start',
		// justifyContent: 'flex-end',
		alignItems: 'center',

		'& svg': {
			marginLeft: '8px',
			width: '5px',
			minWidth: '5px',
			'& circle': {
				fill: dotColor,
			},
		},
	};

	if (isHover) {
		return {
			...baseStyles,
			'&:hover': {
				cursor: 'pointer',
				textDecoration: 'underline',
				color: `${mainColor} !important`,
			},
		};
	}

	return baseStyles;
};

export const formatTablePhoneNumber = (inputStr?: string) => {
	if (inputStr) return `${inputStr.slice(0, 3)} ${inputStr.slice(3, 6)}-${inputStr.slice(6)}`;
	return '';
};

export const getTableSortChanges = (
	newSortColumn: string,
	filterValues: any,
	setFilterValues: React.Dispatch<React.SetStateAction<any>>
) => {
	const isAsc = filterValues.sortColumn !== newSortColumn || !filterValues.isOrderDesc;

	setFilterValues((prevState: any) => ({
		...prevState,
		isOrderDesc: isAsc,
		sortColumn: newSortColumn,
	}));
};
